<template>
  <div class="form-row inline-label">
    <div class="form-column">
      <label>{{ $t('paymentSelection.termOverview.title') }}</label>
      <table class="term-overview">
        <thead>
          <tr>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.product') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.payDirect') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.nrOfMonthlyTerms') }}</th>
            <th>{{ $t('paymentSelection.termOverview.tableColumn.payRemaining') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(productItem, key) in cartProductItems" :key="key">
            <td>{{ productItem.productTitle }}</td>
            <td class="downPaymentAmount">{{ $n(getDirectAmount(productItem), 'currency') }}</td>
            <td class="monthlyTerms">{{ $n(getMonthlyTermAmount(productItem), 'currency') }}</td>
            <td class="remainingAmount">{{ getTermAmount(productItem) ? $n(getTermAmount(productItem), 'currency') : $t('paymentSelection.termOverview.doesNotApply') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'AbtTermOverview',
  props: {
    cartProductItems: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters({
      paymentConfigurations: 'payment/paymentConfigurations'
    })
  },
  methods: {
    getDirectAmount (productItem) {
      return productItem.directPayment ? productItem.directPayment.totalPriceLine.amountWithVat.amount : 0
    },
    getTermAmount (productItem) {
      if (!this.paymentConfigurations.hasOwnProperty(productItem.orderItemId)) {
        return null
      }

      const paymentConfiguration = this.paymentConfigurations[productItem.orderItemId]
      const isPermanent = paymentConfiguration.paymentTermConfigurations
        .filter(configuration => (configuration.type === 'DIRECT')).length === 0

      if (isPermanent) {
        return null
      }

      return productItem.termPayments.length ? productItem.termPayments.reduce(
        (totalTermAmount, termPayment) => totalTermAmount + termPayment.totalPriceLine.amountWithVat.amount,
        0
      ) : 0
    },
    getMonthlyTermAmount (productItem) {
      return productItem.termPayments.length ? productItem.termPayments[1].totalPriceLine.amountWithVat.amount : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/payment-selection/AbtTermOverview.vue